import { toAbsoluteImageUrl } from '@/shared/libs/helpers';
import { sectionSchema } from '@/shared/utils/seo';

export function carouselEPGSchema(channelList) {
  if (channelList === '' || channelList.length) {
    sectionSchema();
    return;
  }
  let a = 0;
  const array = channelList.flatMap((items) => {
    return items.programs.map((programme) => {
      a++;

      return {
        '@context': 'https://schema.org',
        '@type': 'VideoObject',
        contentUrl: programme.canonicalUrl,
        description: programme.description,
        name: programme.title,
        thumbnailUrl: [
          programme?.images?.['16x9']?.[0]?.mainUrl,
          programme?.images?.['1x1']?.[0]?.mainUrl,
          programme?.images?.['3x4']?.[0]?.mainUrl,
        ].map(toAbsoluteImageUrl).filter(Boolean),
        position: a,
        publication: [
          {
            '@type': 'BroadcastEvent',
            isLiveBroadcast: true,
            startDate: new Date(programme.since).toISOString(),
            endDate: new Date(programme.till).toISOString(),
          },
        ],
        uploadDate: new Date(programme.since).toISOString(),
      };
    });
  });
  carouselSchema(array);
}

function carouselSchema(array) {
  const jsonLinkedData = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: array,
  };
  document.getElementById('scriptJSON').innerText = JSON.stringify(jsonLinkedData);
}
